import React, { useState, useEffect } from "react";
import { imgSet } from "../lib/img";

const CustomCarousel = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const count = images.length;

  useEffect(() => {
    if (count < 2) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % count);
    }, 10000); // Auto-slide every 10 seconds
    return () => clearInterval(interval);
  }, [count]);

  if (!Array.isArray(images) || images.length === 0) {
    return <p className="text-center text-gray-500">No images available.</p>;
  }

  // Only the active slide and its immediate neighbors are worth loading; the
  // rest stay unmounted so the browser doesn't fetch every full image up front.
  const isNear = (index) => {
    if (index === currentIndex) return true;
    const next = (currentIndex + 1) % count;
    const prev = (currentIndex - 1 + count) % count;
    return index === next || index === prev;
  };

  return (
    <div className="relative w-full max-w-4xl min-h-[800px] overflow-hidden rounded-xl shadow-lg">
    {images.map((image, index) => {
      const v = imgSet(image.src);
      return (
      <div
        key={index}
        className={`absolute inset-0 transition-opacity duration-700 ease-in-out w-full h-full ${
          index === currentIndex ? "opacity-100" : "opacity-0"
        }`}
      >
        {isNear(index) && (
          <img
            src={v.full}
            srcSet={v.srcSet}
            sizes="(min-width: 896px) 896px, 100vw"
            decoding="async"
            loading={index === 0 ? "eager" : "lazy"}
            fetchPriority={index === currentIndex ? "high" : "low"}
            alt={image.alt}
            className="w-full h-full object-cover transition-all duration-500"
          />
        )}
        <div className="absolute bottom-0 left-0 w-full p-4 text-sm text-white bg-black bg-opacity-30 hover:bg-opacity-50 transition-opacity duration-500">
            {image.text}
        </div>
      </div>
      );
    })}
    
    <button
      className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-80"
      onClick={() => setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1))}
    >
      &#10094;
    </button>
    <button
      className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-80"
      onClick={() => setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)}
    >
      &#10095;
    </button>
  </div>
  );
};

export default function ProjectTemplate({ title, images }) {
  return (
    <div className="flex flex-col items-center bg-gray-100 p-6">
              <header className="w-full max-w-4xl bg-white shadow-md rounded-2xl p-4 mb-6 text-center">
        <h1 className="text-2xl font-bold">{title}</h1>
      </header>

      <main className="w-full max-w-4xl bg-white shadow-md rounded-2xl p-6 flex-1">
        <CustomCarousel images={images} />
      </main>
    </div>
  );
}

export { CustomCarousel };
